<script>
import LoadingView from "./LoadingView.vue";
export default {
  components: {
    LoadingView
  },
  props: {
    id: String
  },
  data() {
    return {
      finished: false,
      isShowMask: false,
      postMask: ""
    };
  },
  mounted() {
    const gameType = this.$route.params.type || "shijuejiqiao-dadishu/";
    const playbackId = this.id || this.$route.params.id
    this.$el.firstElementChild.src = `${this.$resourceUrl}/${gameType}/index.html?playbackId=${playbackId}`;
    this.$el.firstElementChild.style.width =
      document.documentElement.clientWidth + "px";
    this.$el.firstElementChild.style.height =
      document.documentElement.clientHeight + "px";
    window.onresize = () => {
      this.$el.firstElementChild.style.width =
        document.documentElement.clientWidth + "px";
      this.$el.firstElementChild.style.height =
        document.documentElement.clientHeight + "px";
    };
    window.addEventListener("message", this.postToken, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.postToken);
  },
  methods: {
    postToken(e) {
      let tokenMessage = localStorage.getItem("token");
      if (this.isJsonString(e.data)) {
        let data = e.data;
        data = JSON.parse(data);
        this.eData = data;
        if (data.type === "getPixelInfo") {
          let messData = JSON.parse(localStorage.getItem("data"));
          document.querySelector(".ScreenIframe").contentWindow.focus();
          let jsonData = JSON.stringify({
            type: "getPixelInfo",
            data: messData
          });
          window.frames[0].postMessage(jsonData, "*");
          this.finished = true;
        } else if (data.type == "postMask") {
          this.isShowMask = true;
          this.postMask = data.data;
        }
      } else if (e.data === "loadFinished") {
        this.isShowMask = false;
        this.finished = true;
        document.querySelector(".ReplayIframe").contentWindow.focus();
      } else if (e.data === "quit") {
        let url = this.$route.fullPath;
        let urlAry = url.split("/");
        urlAry.pop();
        urlAry.pop();
        url = urlAry.join("/");
        this.$router.push({ path: `${url}` });
      } else if (e.data === "authenticationFailed") {
        this.$router.replace("/login");
      } else if (e.data == "requestToken") {
        window.frames[0].postMessage(`token:${tokenMessage}`, "*");
      } else if (e.data == "") {
      }
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {}
      return false;
    },
    clickBack() {
      this.loadingQuit = true;
      let url = this.$route.fullPath;
      let urlAry = url.split("/");
      urlAry.pop();
      urlAry.pop();
      url = urlAry.join("/");
      this.$router.push({
        path: `${url}`
      });
    }
  }
};
</script>

<template>
  <div>
    <img class="mask" v-if="isShowMask" :src="postMask" />
    <iframe class="ReplayIframe" frameborder="no"></iframe>
    <LoadingView :finished="finished" @clickBack="clickBack" />
  </div>
</template>

<style lang="scss" scoped>
.ReplayIframe {
  position: fixed;
  top: 0;
  left: 0;
}
.mask {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}
</style>





// WEBPACK FOOTER //
// src/components/visionTrainTrack/ReplayIframe.vue